/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ADAPTED_FACES_PAIN_SCALE = 'adapted-faces-pain-scale',
  ADJUST_INFUSION_SPEED = 'adjust-infusion-speed',
  ADMINISTRATION_BY_SCHEDULE = 'administration-by-schedule',
  ADMINISTRATION_SCHEDULE_FRACTIONAL_DOSE = 'administration-schedule-fractional-dose',
  ADULT_TPN_INTERUPT = 'adult-tpn-interupt',
  ADULT_TPN_START = 'adult-tpn-start',
  ADULT_TPN_TERMINATE = 'adult-tpn-terminate',
  ADULT_TPN_VIEWER = 'adult-tpn-viewer',
  ANALOGIC_FACES_PAIN_SCALE = 'analogic-faces-pain-scale',
  APPLICATION = 'application',
  BACKUP_BRACELET_CONFIRMATION = 'backup-bracelet-confirmation',
  BACKUP_PRESCRIPTION = 'backup-prescription',
  BEHAVIOR_PAIN_SCALE = 'behavior-pain-scale',
  BLADDER_IRRIGATION_RESCHEDULE = 'bladder-irrigation-reschedule',
  BLADDER_IRRIGATION_REVERSE = 'bladder-irrigation-reverse',
  BLADDER_IRRIGATION_START = 'bladder-irrigation-start',
  BLADDER_IRRIGATION_TERMINATE = 'bladder-irrigation-terminate',
  BLADDER_IRRIGATION_VIEWER = 'bladder-irrigation-viewer',
  BLOOD_MANAGEMENT_INTERRUPT = 'blood-management-interrupt',
  BLOOD_MANAGEMENT_REACTION = 'blood-management-reaction',
  BLOOD_MANAGEMENT_REVERSE = 'blood-management-reverse',
  BLOOD_MANAGEMENT_START = 'blood-management-start',
  BLOOD_MANAGEMENT_TERMINATE = 'blood-management-terminate',
  BLOOD_MANAGEMENT_VIEWER = 'blood-management-viewer',
  BLOOD_PRODUCTS_VIEW_FRAGMENT = 'blood-products-view-fragment',
  BRACELET_CONFIRMATION = 'bracelet-confirmation',
  CHANGE_PATIENT = 'change-patient',
  CHANGE_PATIENT_CONFIRMATION = 'change-patient-confirmation',
  CHANGE_PATIENT_INFORMATION = 'change-patient-information',
  CHANGE_PATIENT_LOCATION = 'change-patient-location',
  CHANGE_PATIENT_SEARCH = 'change-patient-search',
  CHEMO_ENCONTERS_LIST = 'chemo-enconters-list',
  CHEMO_START_ADM = 'chemo-start-adm',
  CHEMOTHERAPY = 'chemotherapy',
  CLINICAL_NOTES_AUTO_STANDARD_TEXT = 'clinical-notes-auto-standard-text',
  CLINICAL_NOTES_CONSENT = 'clinical-notes-consent',
  CLINICAL_NOTES_DESCRIPTION = 'clinical-notes-description',
  CLINICAL_NOTES_EDITOR = 'clinical-notes-editor',
  CLINICAL_NOTES_INSTITUTION_STANDARD_TEXT = 'clinical-notes-institution-standard-text',
  CLINICAL_NOTES_LIST = 'clinical-notes-list',
  CLINICAL_NOTES_MENU = 'clinical-notes-menu',
  CLINICAL_NOTES_MY_STANDARD_TEXT = 'clinical-notes-my-standard-text',
  CLINICAL_NOTES_VIEWER = 'clinical-notes-viewer',
  COMFORT_B_SCALE = 'comfort-b-scale',
  CONFIRM_EXAM_COLLECTION_UNLABELLED = 'confirm-exam-collection-unlabelled',
  CONSENT_TRANSCRIPT = 'consent-transcript',
  COOKIES_POLICY = 'cookies-policy',
  CPOE = 'cpoe',
  CPOE_DECK = 'cpoe-deck',
  CPOT_PAIN_SCALE = 'cpot-pain-scale',
  CRIES_PAIN_SCALE = 'cries-pain-scale',
  DELIVERING_MEALS_BY_SEQUENCE = 'delivering-meals-by-sequence',
  DEVICE_EVENT_ACTION = 'device-event-action',
  DEVICES_ANOTHER_ACTION = 'devices-another-action',
  DEVICES_CREATE = 'devices-create',
  DEVICES_EVENTS_LIST = 'devices-events-list',
  DEVICES_LIST = 'devices-list',
  DEVICES_REMOVE_ACTION = 'devices-remove-action',
  DEVICES_REPLACE_ACTION = 'devices-replace-action',
  DEVICES_VIEWER = 'devices-viewer',
  DIAGNOSIS = 'diagnosis',
  DIAGNOSIS_DESCRIPTION = 'diagnosis-description',
  DIAGNOSIS_EDITOR = 'diagnosis-editor',
  DIAGNOSIS_INACTIVATION = 'diagnosis-inactivation',
  DIAGNOSIS_VIEWER = 'diagnosis-viewer',
  DINAMYC_FIELD_TES = 'dinamyc-field-tes',
  DRESSINGS_CREATE = 'dressings-create',
  DRESSINGS_INACTIVATE = 'dressings-inactivate',
  DRESSINGS_LIST = 'dressings-list',
  DRESSINGS_VIEWER = 'dressings-viewer',
  EC_PRESCRIPTIONS_LIST = 'ec-prescriptions-list',
  ELECTRONIC_MEDICATION_ADMINISTRATION = 'electronic-medication-administration',
  ELECTRONIC_PATIENT_CHART = 'electronic-patient-chart',
  ELECTRONIC_SERVICE_REASON_JUSTIFICATION = 'electronic-service-reason-justification',
  ELECTRONIC_SERVICE_TIMELINE = 'electronic-service-timeline',
  ELETRONIC_SERVICE_PERSONAL_INFORMATION = 'eletronic-service-personal-information',
  ELETRONIC_SERVICE_PERSONAL_INFORMATION_ALL_TAB = 'eletronic-service-personal-information-all-tab',
  ENCOUNTER_PATIENT_DETAIL = 'encounter-patient-detail',
  ENCOUNTER_PATIENT_DETAIL_CPOE = 'encounter-patient-detail-cpoe',
  ENTERAL_NUTRITION_INTERRUPT = 'enteral-nutrition-interrupt',
  ENTERAL_NUTRITION_START = 'enteral-nutrition-start',
  ENTERAL_NUTRITION_TERMINATE = 'enteral-nutrition-terminate',
  ENTERAL_NUTRITION_VIEWER = 'enteral-nutrition-viewer',
  EXAM_COLLECTION = 'exam-collection',
  FLACC_PAIN_SCALE = 'flacc-pain-scale',
  FOOTER = 'footer',
  GASTHERAPY_REVERSE_OR_INTERRUPT = 'gastherapy-reverse-or-interrupt',
  GASTHERAPY_START_OR_RESTART_MODAL = 'gastherapy-start-or-restart-modal',
  GASTHERAPY_SUSPEND = 'gastherapy-suspend',
  GASTHERAPY_TERMINATE = 'gastherapy-terminate',
  GASTHERAPY_VIEWER = 'gastherapy-viewer',
  GENERATE_PATIENT_REFUSAL = 'generate-patient-refusal',
  GENERATE_TAG_DATA = 'generate-tag-data',
  GLYCEMIC_ADMINISTRATION = 'glycemic-administration',
  GLYCEMIC_DETAILS = 'glycemic-details',
  GLYCEMIC_INFO_CARD_FRAGMENT = 'glycemic-info-card-fragment',
  GLYCEMIC_RESCHEDULE = 'glycemic-reschedule',
  HANDLING_ORDER_ITEMS = 'handling-order-items',
  HEALTH_HISTORY_ALLERGIES_CREATE = 'health-history-allergies-create',
  HEALTH_HISTORY_ALLERGIES_EDIT = 'health-history-allergies-edit',
  HEALTH_HISTORY_ALLERGIES_LIST = 'health-history-allergies-list',
  HEALTH_HISTORY_ALLERGIES_VIEWER = 'health-history-allergies-viewer',
  HEALTH_HISTORY_DISEASES_CREATE = 'health-history-diseases-create',
  HEALTH_HISTORY_DISEASES_EDIT = 'health-history-diseases-edit',
  HEALTH_HISTORY_DISEASES_LIST = 'health-history-diseases-list',
  HEALTH_HISTORY_DISEASES_VIEWER = 'health-history-diseases-viewer',
  HEALTH_HISTORY_INACTIVATE = 'health-history-inactivate',
  HEALTH_HISTORY_LIST = 'health-history-list',
  HEALTH_HISTORY_MEDICINES_CREATE = 'health-history-medicines-create',
  HEALTH_HISTORY_MEDICINES_EDIT = 'health-history-medicines-edit',
  HEALTH_HISTORY_MEDICINES_LIST = 'health-history-medicines-list',
  HEALTH_HISTORY_MEDICINES_VIEWER = 'health-history-medicines-viewer',
  HEALTH_HISTORY_SOCIAL_HISTORY_CREATE = 'health-history-social-history-create',
  HEALTH_HISTORY_SOCIAL_HISTORY_EDIT = 'health-history-social-history-edit',
  HEALTH_HISTORY_SOCIAL_HISTORY_LIST = 'health-history-social-history-list',
  HEALTH_HISTORY_SOCIAL_HISTORY_VIEWER = 'health-history-social-history-viewer',
  HYDRIC_BALANCE = 'hydric-balance',
  INFORM_REASON_ARRIVAL = 'inform-reason-arrival',
  INFORMATION_BAR_HEADER = 'information-bar-header',
  INFUSION_ADMINISTRATION_BY_SCHEDULE = 'infusion-administration-by-schedule',
  INFUSION_INTERRUPT_SOLUTION = 'infusion-interrupt-solution',
  INFUSION_RECORD_PARTIAL_VOLUME = 'infusion-record-partial-volume',
  INFUSION_REVERSE_LAST_EVENT = 'infusion-reverse-last-event',
  INFUSION_SOLUTION_DETAIL_STEP = 'infusion-solution-detail-step',
  INFUSION_SUSPEND = 'infusion-suspend',
  INFUSION_SUSPEND_WITH_JUSTIFICATION = 'infusion-suspend-with-justification',
  INFUSION_SUSPEND_WITHOUT_JUSTIFICATION = 'infusion-suspend-without-justification',
  INFUSION_TERMINATE = 'infusion-terminate',
  INFUSIONS_VIEWER = 'infusions-viewer',
  INTAKES_AND_OUTPUTS = 'intakes-and-outputs',
  INTAKES_AND_OUTPUTS_EDITOR = 'intakes-and-outputs-editor',
  INTAKES_AND_OUTPUTS_INACTIVATE = 'intakes-and-outputs-inactivate',
  INTAKES_AND_OUTPUTS_LIST = 'intakes-and-outputs-list',
  INTAKES_AND_OUTPUTS_RETROACTIVE_JUSTIFICATION = 'intakes-and-outputs-retroactive-justification',
  INTAKES_AND_OUTPUTS_VIEWER = 'intakes-and-outputs-viewer',
  LAB_EXAMS_DETAILS = 'lab-exams-details',
  LAB_EXAMS_LIST = 'lab-exams-list',
  LIGHT_FACES_PAIN_SCALE = 'light-faces-pain-scale',
  LOCATOR_ACTIVE_INGREDIENT = 'locator-active-ingredient',
  LOCATOR_DCB = 'locator-dcb',
  LOCATOR_FAMILY = 'locator-family',
  LOCATOR_MATERIAL_MEDICINE = 'locator-material-medicine',
  LOCATOR_MATERIAL_MEDICINE_CLASS = 'locator-material-medicine-class',
  LOCATOR_MEDICINE_IN_USE = 'locator-medicine-in-use',
  LOCATOR_TABLE_LIST = 'locator-table-list',
  LOGIN_FOUNDATION = 'login-foundation',
  LOGOUT_INACTIVITY = 'logout-inactivity',
  MEAL_DELIVERY = 'meal-delivery',
  MEAL_DELIVERY_PATIENT = 'meal-delivery-patient',
  MEDICAL_PRESCRIPTIONS_LIST = 'medical-prescriptions-list',
  MEDICATION_ADMINISTRATION_BY_PROCESS = 'medication-administration-by-process',
  MEDICATION_AND_DATE_HEADER = 'medication-and-date-header',
  MEDICATION_SCHEDULE = 'medication-schedule',
  MEDICATION_SUSPEND = 'medication-suspend',
  MEDICATION_VIEWER = 'medication-viewer',
  MEDICINE_AND_SOLUTIONS = 'medicine-and-solutions',
  MEDICINE_VIEW_FRAGMENT = 'medicine-view-fragment',
  MILK_AND_DERIVATIVES_EXECUTE = 'milk-and-derivatives-execute',
  MILK_AND_DERIVATIVES_VIEWER = 'milk-and-derivatives-viewer',
  MODIFIED_PAIN_BEHAVIORAL = 'modified-pain-behavioral',
  MOPS_PAIN_SCALE = 'mops-pain-scale',
  NEONATAL_TPN_INTERRUPT = 'neonatal-tpn-interrupt',
  NEONATAL_TPN_START = 'neonatal-tpn-start',
  NEONATAL_TPN_TERMINATE = 'neonatal-tpn-terminate',
  NEONATAL_TPN_VIEWER = 'neonatal-tpn-viewer',
  NFCS_PAIN_SCALE = 'nfcs-pain-scale',
  NIPS_PAIN_SCALE = 'nips-pain-scale',
  NON_LAB_EXAM_DETAIL = 'non-lab-exam-detail',
  NON_LAB_EXAM_DETAIL_IMAGES = 'non-lab-exam-detail-images',
  NON_LAB_EXAMS_LIST = 'non-lab-exams-list',
  NOTAS_CLINICAS = 'notas-clinicas',
  NURSING_INTERVENTIONS_EMAR_RECORDS = 'nursing-interventions-emar-records',
  NURSING_INTERVENTIONS_RESCHEDULE = 'nursing-interventions-reschedule',
  NURSING_INTERVENTIONS_REVERSE = 'nursing-interventions-reverse',
  NURSING_INTERVENTIONS_START = 'nursing-interventions-start',
  NURSING_INTERVENTIONS_VIEW_FRAGMENT = 'nursing-interventions-view-fragment',
  NURSING_INTERVENTIONS_VIEWER = 'nursing-interventions-viewer',
  NUTRITION_ENTERAL_DIET_VIEW_FRAGMENT = 'nutrition-enteral-diet-view-fragment',
  NUTRITION_FASTING_VIEW = 'nutrition-fasting-view',
  NUTRITION_MILK_AND_DERIVATIVES_VIEW_FRAGMENT = 'nutrition-milk-and-derivatives-view-fragment',
  NUTRITION_ORAL_DIET_VIEW_FRAGMENT = 'nutrition-oral-diet-view-fragment',
  NUTRITION_SUPPLEMENTS_VIEW_FRAGMENT = 'nutrition-supplements-view-fragment',
  NUTRITION_WATER_BALANCE = 'nutrition-water-balance',
  ONGOING_INFUSIONS = 'ongoing-infusions',
  ORAL_DIET_EXECUTE_TIME_MODAL = 'oral-diet-execute-time-modal',
  ORAL_DIET_VIEWER = 'oral-diet-viewer',
  ORAL_SUPPLEMENTS_EXECUTE_TIME_MODAL = 'oral-supplements-execute-time-modal',
  ORAL_SUPPLEMENTS_VIEWER = 'oral-supplements-viewer',
  PATIENT_ARRIVAL_CONFIRMATION = 'patient-arrival-confirmation',
  PATIENT_DISPLACEMENT = 'patient-displacement',
  PATIENT_DISPLACEMENT_CHANGE_PATIENT_LOCATION = 'patient-displacement-change-patient-location',
  PATIENT_DISPLACEMENT_PERSON_INFORMATION = 'patient-displacement-person-information',
  PATIENT_EVOLUTION = 'patient-evolution',
  PATIENT_EVOLUTION_DELETE = 'patient-evolution-delete',
  PATIENT_EVOLUTION_INACTIVATION = 'patient-evolution-inactivation',
  PATIENT_EVOLUTION_SUBMIT = 'patient-evolution-submit',
  PATIENT_LIST = 'patient-list',
  PATIENT_OUT_CONFIRMATION = 'patient-out-confirmation',
  PATIENT_PRESCRIPTIONS_ALL_TAB = 'patient-prescriptions-all-tab',
  PATIENT_ROOM_CHECK = 'patient-room-check',
  PATIENT_TRANSFER_CONFIRMATION = 'patient-transfer-confirmation',
  PD_PAIN_SCALE = 'pd-pain-scale',
  PENDING_EXAM_COLLECTION = 'pending-exam-collection',
  PEP_SECURITY_ALERT = 'pep-security-alert',
  PHYSICIAN_SCHEDULE_APPOINTMENTS_DETAIL = 'physician-schedule-appointments-detail',
  PHYSICIAN_SCHEDULE_BLOCK = 'physician-schedule-block',
  PHYSICIAN_SCHEDULE_BLOCK_DETAIL = 'physician-schedule-block-detail',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL = 'physician-schedule-block-individual',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT = 'physician-schedule-block-individual-edit',
  PHYSICIAN_SCHEDULE_VIEWER = 'physician-schedule-viewer',
  PRESCRIPTION_REPORT = 'prescription-report',
  PRIVACY_NOTICE = 'privacy-notice',
  PRIVACY_NOTICE_DETAIL = 'privacy-notice-detail',
  PROFILE = 'profile',
  RECOMMENDATION_EXECUTE_TIME_MODAL = 'recommendation-execute-time-modal',
  RECOMMENDATION_VIEW_FRAGMENT = 'recommendation-view-fragment',
  RECOMMENDATION_VIEWER = 'recommendation-viewer',
  RECORDING_OF_CONSENT = 'recording-of-consent',
  RESERVED_BLOOD_PRODUCTS = 'reserved-blood-products',
  RESERVED_BLOOD_PRODUCTS_INTERRUPT = 'reserved-blood-products-interrupt',
  RESERVED_BLOOD_PRODUCTS_RESTART = 'reserved-blood-products-restart',
  RESERVED_BLOOD_PRODUCTS_REVERSE = 'reserved-blood-products-reverse',
  RESERVED_BLOOD_PRODUCTS_START = 'reserved-blood-products-start',
  RESERVED_BLOOD_PRODUCTS_SUSPEND = 'reserved-blood-products-suspend',
  RESERVED_BLOOD_PRODUCTS_TERMINATE = 'reserved-blood-products-terminate',
  RESERVED_BLOOD_PRODUCTS_VIEWER = 'reserved-blood-products-viewer',
  RESPIRATORY_MONITORING = 'respiratory-monitoring',
  RESPIRATORY_MONITORING_EDITOR = 'respiratory-monitoring-editor',
  RESPIRATORY_MONITORING_INACTIVATE = 'respiratory-monitoring-inactivate',
  RESPIRATORY_MONITORING_VIEWER = 'respiratory-monitoring-viewer',
  RESULTADOS_EXAMES = 'resultados-exames',
  REVERSE_ENTERAL_NUTRITION = 'reverse-enteral-nutrition',
  REVERSE_MEDICATION = 'reverse-medication',
  REVERSE_TPN = 'reverse-tpn',
  ROOT = 'root',
  ROOT_ADEP = 'root_adep',
  ROOT_DOUBLE_CONFERENCE = 'root_double-conference',
  ROOT_EC = 'root-ec',
  ROOT_PHYSICIAN_SCHEDULE = 'root_physician-schedule',
  SAE_LOCATOR = 'sae-locator',
  SCALE_MORSE_LIST = 'scale-morse-list',
  SCHEDULE_MEDICATION_INFUSIONS = 'schedule-medication-infusions',
  SCHEDULE_SUPPLEMENTS = 'schedule-supplements',
  SCORE_DINI_CREATE = 'score-dini-create',
  SCORE_DINI_EDIT = 'score-dini-edit',
  SCORE_DINI_LIST = 'score-dini-list',
  SCORE_DINI_VIEWER = 'score-dini-viewer',
  SCORE_FLEX_CREATE = 'score-flex-create',
  SCORE_FLEX_LIST = 'score-flex-list',
  SCORE_INACTIVATE = 'score-inactivate',
  SCORE_MEWS_CREATE = 'score-mews-create',
  SCORE_MEWS_EDIT = 'score-mews-edit',
  SCORE_MEWS_LIST = 'score-mews-list',
  SCORE_MEWS_VIEWER = 'score-mews-viewer',
  SCORE_MORSE_CREATE = 'score-morse-create',
  SCORE_MORSE_EDIT = 'score-morse-edit',
  SCORE_MORSE_LIST = 'score-morse-list',
  SCORE_MORSE_VIEWER = 'score-morse-viewer',
  SCORE_NAS_CREATE = 'score-nas-create',
  SCORE_NAS_EDIT = 'score-nas-edit',
  SCORE_NAS_LIST = 'score-nas-list',
  SCORE_NAS_VIEWER = 'score-nas-viewer',
  SCORE_NRS_CREATE = 'score-nrs-create',
  SCORE_NRS_EDIT = 'score-nrs-edit',
  SCORE_NRS_LIST = 'score-nrs-list',
  SCORE_NRS_VIEWER = 'score-nrs-viewer',
  SCORE_PEWS_CREATE = 'score-pews-create',
  SCORE_PEWS_EDIT = 'score-pews-edit',
  SCORE_PEWS_LIST = 'score-pews-list',
  SCORE_PEWS_VIEWER = 'score-pews-viewer',
  SCORE_REFERENCE = 'score-reference',
  SCORE_TISS_28_CREATE = 'score-tiss-28-create',
  SCORE_TISS_28_EDIT = 'score-tiss-28-edit',
  SCORE_TISS_28_LIST = 'score-tiss-28-list',
  SCORE_TISS_28_VIEWER = 'score-tiss-28-viewer',
  SCORES_LIST = 'scores-list',
  SEARCH_PATIENT_DISPLACEMENT = 'search-patient-displacement',
  SEARCH_PATIENT_EC = 'search-patient-ec',
  SEARCH_PATIENT_EMAR = 'search-patient-emar',
  SEARCH_PATIENT_MEAL_DELIVERY = 'search-patient-meal-delivery',
  SEARCH_PATIENT_QU = 'search-patient-qu',
  SECURITY_ALERT = 'security-alert',
  SELECT_ONGOING_NURSING_INTERVENTIONS = 'select-ongoing-nursing-interventions',
  SELECTED_PENDING_EXAMS = 'selected-pending-exams',
  SEND_CONTAINER = 'send-container',
  SEND_EXAM_SAMPLE = 'send-exam-sample',
  SEND_PRESCRIPTION = 'send-prescription',
  SEND_PRESCRIPTION_CONTEXT = 'send-prescription-context',
  SPOTLIGHT = 'spotlight',
  START_END_ADM_CHEMO = 'start-end-admChemo',
  SUEP = 'suep',
  SUEP_CHANGE_MODEL_MODAL = 'suep-change-model-modal',
  SURGICAL = 'surgical',
  SURGICAL_OPTIONS = 'surgical-options',
  SUSPEND_GLYCEMIC = 'suspend-glycemic',
  SUSPEND_ITEM = 'suspend-item',
  TERMS_AND_COOKIES_LIST = 'terms-and-cookies-list',
  TERMS_OF_USE = 'terms-of-use',
  TERMS_OF_USE_DETAIL = 'terms-of-use-detail',
  USER_DETAILS = 'user-details',
  VALIDATE_HANDLING_ORDER = 'validate-handling-order',
  VITAL_SIGN_AND_RESPIRATORY_MONITORING = 'vital-sign-and-respiratory-monitoring',
  VITAL_SIGN_CREATE_AND_EDIT = 'vital-sign-create-and-edit',
  VITAL_SIGN_INACTIVATE = 'vital-sign-inactivate',
  VITAL_SIGN_LIST = 'vital-sign-list',
  VITAL_SIGN_MENU = 'vital-sign-menu',
  VITAL_SIGN_PAIN_SCALE_FIELD = 'vital-sign-pain-scale-field',
  WOUND_PICTURE_EDIT = 'wound-picture-edit',
  WOUNDS_CREATE = 'wounds-create',
  WOUNDS_DRESSINGS_INACTIVATE = 'wounds-dressings-inactivate',
  WOUNDS_DRESSINGS_LIST = 'wounds-dressings-list',
  WOUNDS_DRESSINGS_TAB_LIST = 'wounds-dressings-tab-list',
  WOUNDS_EDIT = 'wounds-edit',
  WOUNDS_END_TREATMENT = 'wounds-end-treatment',
  WOUNDS_IMAGES_LIST = 'wounds-images-list',
  WOUNDS_VIEWER = 'wounds-viewer',
}
export { FragmentNames };
